<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="mb-2">
          <b-row>
            <b-col cols="10" class="h3 mb-1">
              <span variant="primary">Configuración de Comentarios</span>
            </b-col>
            <b-col>
              <b-button @click="agregar()" variant="primary" class="m-1">
                <b-iconstack font-scale="1" class="ml-1" title="Agregar">
                  <b-icon stacked icon="plus" shift-h="-15"></b-icon>
                  <b-icon stacked icon="chat-square-text-fill"></b-icon>
                </b-iconstack>
                <span class="ml-3">Agregar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <loading :active="isLoading" :is-full-page="true"></loading>
      <b-col>
        <b-card no-body>
          <b-table sticky-header no-border-collapse head-variant="light" style="min-height: 60vh;" :items="items"
            :fields="commentsFields" responsive>
            <template #cell(x_title)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-input v-model="data.item.x_title">asd</b-input>
              </div>
              <div v-else>
                {{ data.item.x_title }}
              </div>
            </template>
            <template #cell(x_comment)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-input v-model="data.item.x_comment">asd</b-input>
              </div>
              <div v-else>
                {{ data.item.x_comment }}
              </div>
            </template>
            <template #cell(actions)="data">
              <b-icon @click='guardar(data.item, data.index)' v-if="edit[data.index]" icon=check-lg
                class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Guardar" variant="success"></b-icon>
              <b-icon @click='cancelar(data.index)' v-if="edit[data.index]" icon=x-lg
                class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Cancelar"
                variant="danger"></b-icon>
              <b-icon @click='editar(data.index)' v-if="!edit[data.index]" icon=pencil-square
                class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Editar" variant="primary"></b-icon>
              <b-icon @click='borrar(data.item.id)' v-if="!edit[data.index]" icon=archive-fill
                class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Archivar"
                variant="primary"></b-icon>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { CommentsService } from '@/services/comments.service'
import Loading from 'vue-loading-overlay'

export default {
  name: 'Comments',
  data () {
    return {
      isLoading: true,
      edit: {},
      items: [],
      commentsFields: [
        { key: 'x_title', label: 'Código', sortable: true },
        { key: 'x_comment', label: 'Comentario' },
        { key: 'actions', label: 'Acciones' }
      ]
    }
  },
  components: {
    Loading
  },
  watch: {},
  computed: {},
  async created () {
    this.isLoading = true
    await this.updateLista()
    this.isLoading = false
  },
  methods: {
    updateLista: async function () {
      try {
        this.items = await CommentsService.list()

        console.log(this.items, 'holis')
      } catch (error) {
        console.log(error)
      }
    },
    agregar () {
      this.isLoading = true
      this.items.push({
        x_title: '',
        x_comment: null
      })
      this.edit[this.items.length - 1] = true
      this.isLoading = false
    },
    cancelar (index) {
      console.log(this.edit, 'edit')
      this.isLoading = true
      if (!this.items[index].id) {
        this.items.splice(index, 1)
      } else {
        console.log(this.edit[index], 'arriba')
        this.edit[index] = false
        console.log(this.edit[index], 'abajo')
      }
      this.isLoading = false
    },
    async guardar (item, index) {
      this.isLoading = true
      console.log(item, index)
      if (item.id) {
        const updateItem = {
          x_title: item.x_title,
          x_comment: item.x_comment
        }
        console.log(item, index)
        await CommentsService.update([item.id], updateItem)
        // await this.updateAccountMoves(item)
      } else {
        console.log(item, index)
        this.items[index].id = await CommentsService.create(item)
      }
      this.edit[index] = false
      this.isLoading = false
    },
    async editar (index) {
      if (
        Object.keys(this.edit)[0] !== index &&
        Object.keys(this.edit)[0] !== undefined
      ) {
        delete this.edit[Object.keys(this.edit)[0]]
      }
      this.isLoading = true
      this.edit[index] = true

      this.isLoading = false
    },
    async borrar (id) {
      this.isLoading = true
      try {
        await CommentsService.delete(id)
      } catch (error) {
        this.toastMessage = 'XXX'
        console.log(error)
        this.$bvToast.toast('ERROR', {
          title: 'ERROR'
        })
      }

      await this.updateLista()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
